// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/load-factors-va.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/load-factors-va/load-factors-va.js';
import g1 from '../lessons/aeronautics/load-factors-va/steep-turn-technique.js';

mount([g0, g1]);
